var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 80,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 427319073"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 161",
    cx: 23,
    cy: 23,
    r: 23,
    fill: "#50C24E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 291 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4524 14.7222C36.7104 15.8005 36.8561 17.6944 35.7778 18.9524L23.7778 32.9524C23.2551 33.5621 22.5098 33.9369 21.7087 33.9927C20.9075 34.0486 20.1174 33.7809 19.5152 33.2495L11.0152 25.7495C9.7728 24.6533 9.65431 22.7575 10.7505 21.5151C11.8467 20.2728 13.7425 20.1543 14.9849 21.2505L21.2029 26.7369L31.2223 15.0476C32.3005 13.7896 34.1944 13.644 35.4524 14.7222Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuccess);
export default __webpack_public_path__ + "static/media/icon_success.841111196f1ae332149760ceb80ea48f.svg";
export { ForwardRef as ReactComponent };